import React, { useState } from 'react';
import { useNavigate, useLocation, Link as RouterLink } from 'react-router-dom';
import { TextField, Button, Box, Alert, Link } from '@mui/material';
import { useAuth } from '../../contexts/AuthContext';
import AuthCard, { authFieldSx, authLinkSx } from '../../components/AuthCard';

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const Login = () => {
  const location = useLocation();
  const [email, setEmail] = useState(location.state?.email || '');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [emailError, setEmailError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();
  const notice = location.state?.notice;

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    setEmailError('');

    if (!email) {
      setEmailError('이메일을 입력하세요.');
      return;
    }
    if (!EMAIL_RE.test(email)) {
      setEmailError('유효한 이메일 주소를 입력하세요.');
      return;
    }
    if (!password) {
      setError('비밀번호를 입력하세요.');
      return;
    }

    setLoading(true);
    try {
      const result = await login(email, password);
      if (result.success) {
        navigate(result.user?.isAdmin ? '/admin' : '/settings');
      } else if (result.requiresVerification) {
        navigate(`/verify-email?email=${encodeURIComponent(email)}`);
      } else {
        setError(result.error);
      }
    } catch (err) {
      setError('오류가 발생했습니다. 다시 시도해주세요.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthCard
      title="PlanGo Auth 로그인"
      titleMb={0.75}
    >
      {notice && !error && (
        <Alert severity="success" sx={{ mb: 2 }}>
          {notice}
        </Alert>
      )}
      {error && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {error}
        </Alert>
      )}

      <Box component="form" onSubmit={handleLogin}>
        <TextField
          fullWidth
          id="email"
          placeholder="이메일"
          name="email"
          type="email"
          autoComplete="email"
          autoFocus={!email}
          value={email}
          onChange={(e) => {
            setEmail(e.target.value);
            setEmailError('');
          }}
          error={!!emailError}
          helperText={emailError}
          sx={authFieldSx}
        />

        <TextField
          fullWidth
          name="password"
          placeholder="비밀번호"
          type="password"
          id="password"
          autoComplete="current-password"
          autoFocus={!!email}
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          sx={authFieldSx}
        />

        <Button
          type="submit"
          fullWidth
          variant="contained"
          color="primary"
          disabled={loading || !!emailError}
          sx={{ mt: 2, mb: 0.5, py: 1.5, borderRadius: '4px' }}
        >
          {loading ? '처리 중...' : '로그인 진행'}
        </Button>

        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 1.5 }}>
          <Link
            component={RouterLink}
            to="/forgot-password"
            state={email ? { email } : undefined}
            sx={authLinkSx}
          >
            비밀번호를 잊어버리셨나요?
          </Link>
        </Box>
      </Box>
    </AuthCard>
  );
};

export default Login;
